import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { FileUri } from "api";
import { useContractService } from "contexts/ServiceContext";
import { valueOr } from "util/statHelpers";
import { ApiStatusException } from "services/apiErrors";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";

const mapApiDocumentContractFileUri = (fileUri: FileUri): DocumentsFile => {
  return {
    category: fileUri.Category,
    date: valueOr(fileUri.Date ? new Date(fileUri.Date) : undefined),
    filename: valueOr(fileUri.FileName),
    mimeType: valueOr(fileUri.Mime ?? "application/pdf"),
    url: fileUri.Uri ?? undefined,
  };
};

const useDocumentContractFiles = (): UseMutationResult<
  DocumentsFile[] | undefined,
  ApiStatusException,
  number | undefined
> => {
  const contractService = useContractService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST);
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR);

  return useMutation({
    mutationKey: ["document-files", "contract"],
    mutationFn: (docEntry) => {
      const eventId = trackQuery({
        endpoint: "Quotation/GetFileUriList/{DocEntry}",
        parameters: { docEntry },
      });
      return docEntry
        ? contractService
            .getDocumentContractFileList(docEntry)
            .then((data) => data.value?.map(mapApiDocumentContractFileUri))
            .catch((err) => {
              trackQueryError({ message: err.message }, eventId);
              throw err;
            })
        : Promise.reject();
    },
  });
};

export default useDocumentContractFiles;
